const wrapper = "dibw1ngf3aa";
const input = "dibironi3x";

export { input, wrapper };
import "./text-input.style.linaria.module.css";
//# sourceMappingURL=text-input.style.js.map
